<template>
    <div>
        <template v-if="paymentUnderProcess">
            <payment-under-process :product="this.product"></payment-under-process>
        </template>
        <template v-if="packagePaymentUrl">
            <div class="card-body">
                <div class="row justify-content-center">
                    <package-subscription-payment-screen
                        :adminMode="adminMode"
                        :payment-url="packagePaymentUrl"
                        :payment-amount="packagePaymentAmount"
                        :user="user"/>
                </div>
            </div>
        </template>
        <div v-else>
            <alert-ele v-show="messageText" :message="messageText" :status="messageStatus" @dismiss="()=>this.messageStatus = null"/>
            <div class="card-header py-3">
                <template v-if="user.is_first_subscription">
                    <template v-if="adminMode">
                        <a :href="goBackUrl" class="mx-1" style="color: #3b3f4b">
                            <span class="fa fa-arrow-left"></span>
                        </a>
                    </template>
                    {{ lang.app.subscription.complete_order }}
                    <template v-if="adminMode">
                        <small>(User: {{user.email}})</small>
                    </template>
                </template>
                <template v-else>
                    {{ getHasActiveProductSubscription() ? lang.app.subscription.products_when_active : lang.app.subscription.products }}
                    <template v-if="adminMode">
                        <small>(User: {{user.email}})</small>
                    </template>
                    <br/>
                    <small style="font-size: 0.9rem;">{{ getHasActiveProductSubscription() ? lang.app.subscription.products_subtitle_when_active : lang.app.subscription.products_subtitle }}</small>
                </template>
            </div>
            <div class="card-body">
                <div class="row justify-content-center">
                    <template v-if="user.role === 'advisor'">
                        <div v-if="user.setup_status === 'request-send'" class="col-md-7 col-lg-6 col-xl-5 col-xxl-4 d-flex flex-column">
                            <span class="px-4 mb-2 mt-3">{{ lang.app.subscription.advisor_text_after_sending_request }}</span>
                            <a class="btn btn-block px-5 mt-3 bg-green color-white"
                               href="https://tool.farmdesk.eu/">
                                {{ lang.app.subscription.to_farmdesk }}
                            </a>
                        </div>

                        <div v-else class="col-md-7 col-lg-6 col-xl-5 col-xxl-4 d-flex flex-column">
                            <span v-html="lang.app.subscription.first_product_subscription.advisor_text" class="px-5 mb-2 mt-3"></span>
                            <div class="mt-2">
                                <button-loader :isLoading="submitLoader"
                                               :disabled="submitLoader"
                                               :classes="'btn btn-block px-md-4 mt-3 bg-green color-white'"
                                               @click="advisorRequest">
                                    {{ lang.app.subscription.request_account }}
                                </button-loader>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-md-12 col-lg-10 col-xl-8 col-xxl-6 d-flex flex-column">
                            <div class="row">
                                <div v-if="getHasFreeSubscription()" class="col-12 pb-3">
                                    <ul class="price list-group flex-fill">
                                        <li class="header py-2 bg-green color-white">
                                            {{ lang.app.subscription.package.free_license }}
                                        </li>
                                        <li class="list-group-item" style="cursor: default; background-color: #f8f9fa">
                                            <div class="text-center">
                                                <div class="row">
                                                    <div class="col-12 col-xl-10 offset-xl-1 mb-4">
                                                        {{ lang.app.subscription.package.free_license_desc }}
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div v-else-if="getHasActiveFreeTrialSubscription()" class="col-12 pb-3">
                                    <ul class="price list-group flex-fill">
                                        <li class="header py-2" :style="!getAllowNewOrder() && !getHasActiveProductSubscription() ? {'background-color': '#00DC95', 'color': '#ffffff'} : {}">
                                            {{ lang.app.subscription.package.free_trial_license.header }}
                                        </li>
                                        <li class="list-group-item" style="cursor: default; background-color: #f8f9fa">
                                            <div class="text-center">
                                                <div class="row">
                                                    <div class="col-12 col-xl-10 offset-xl-1 mb-4">
                                                        {{ lang.app.subscription.package.free_trial_license.line1 + ' ' + moment(voucherPackage.to_date).format('DD/MM/YYYY') + '.' }}
                                                        <br>
                                                        {{ lang.app.subscription.package.free_trial_license.voucher_code + ': ' + voucherPackage.voucher_usage_obj.voucher.code }}
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div v-else-if="getHasActivePartnerVoucherSubscription()" class="col-12 pb-3">
                                    <ul class="price list-group flex-fill">
                                        <li class="header py-2 bg-green color-white">
                                            {{ lang.app.subscription.package.partner_voucher.header }}
                                        </li>
                                        <li class="list-group-item" style="cursor: default; background-color: #f8f9fa">
                                            <div class="text-center">
                                                <div class="row">
                                                    <div class="col-12 col-xl-10 offset-xl-1 mb-4">
                                                        {{ lang.app.subscription.package.partner_voucher.line1 + ' ' + (voucherPackage.voucher_usage_obj.voucher.partner ? voucherPackage.voucher_usage_obj.voucher.partner.name : '-') + '.' }}
                                                        <br>
                                                        {{ (voucherPackage.is_unsubscribed ? lang.app.subscription.package.partner_voucher.unsubscribed_line : lang.app.subscription.package.partner_voucher.renewal_line) + ' ' + moment(voucherPackage.to_date).format('DD/MM/YYYY') + '.' }}
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

<!--                                Main module blocks  1) is for all new cow subscription and  2) is to show data of old cow subscription or for non-cow users-->
<!--                                TODO: Remove 2) block once all cow farmers are converted to new subscriptions -->
                                <template v-if="showNewCowPackages()">
                                    <template v-for="(mainPackage, packageIndex) of newCowPackageOptions">
                                        <div v-if="givenNewCowOptionVisible(mainPackage)" :class="['col-12 col-md-6 pb-3', {'offset-md-3': !adminMode || !selectedPackage || selectedPackage.id !== 'cow_yearly_with_s2f'}]">
                                            <ul class="price list-group flex-fill"
                                                :style="{cursor: !getAllowNewOrder() ? 'default' : 'pointer'}"
                                                @click="selectPackage(mainPackage)">
                                                <li class="header py-2" :style="compareWithPackageOption(mainPackage) ? {'background-color': '#00DC95', 'color':'#ffffff'} : {'background-color': '', 'color': ''}">
                                                    {{ mainPackage['title'] }}
                                                    <span class="float-right" v-if="getAllowNewOrder()">
                                                        <input type="checkbox" class="mr-2"
                                                               name="yearly"
                                                               :checked="compareWithPackageOption(mainPackage)"
                                                               :text-before="false">
                                                    </span>
                                                </li>
                                                <li class="list-group-item" :style="{height: '170px', cursor: 'inherit', 'background-color': compareWithPackageOption(mainPackage) ? '#f8f9fa' : ''}">
                                                    <div class="text-center py-2">
                                                        <template v-if="getHasActiveProductSubscription()">
                                                            <template v-if="compareWithPackageOption(mainPackage)">
                                                                <template v-if="selectedPackage.license_to_date">
                                                                    <template v-if="selectedPackage.is_unsubscribed || (nextProductSubscription && !compareWithPackageOption(mainPackage, nextProductSubscription))">
                                                                        <h3 class="pb-3">
                                                                            {{ lang.app.subscription.ends_on }}
                                                                        </h3>
                                                                        <h6 class="pb-2">
                                                                            {{ moment(selectedPackage.license_to_date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY') }}
                                                                        </h6>
                                                                    </template>
                                                                    <template v-else>
                                                                        <h3 class="pb-3">
                                                                            {{ lang.app.subscription.renew_on }}
                                                                        </h3>
                                                                        <h6 class="pb-2">
                                                                            {{ moment(selectedPackage.license_to_date, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('DD/MM/YYYY') }}
                                                                        </h6>
                                                                    </template>
                                                                </template>
                                                                <template v-else>
                                                                    <h3 class="pb-3">
                                                                        &euro; {{ (selectedPackage.priceToDisplay) | floatVal }}
                                                                    </h3>
                                                                    <h6 class="pb-2">
                                                                        {{ mainPackage.durationToDisplay }}
                                                                    </h6>
                                                                </template>

                                                                <div class="my-2 text-center">
                                                                    <small v-if="selectedPackage.is_unsubscribed" class="text-muted d-block">
                                                                        Klik <a href="#" role="button" @click="togglePackageSubscription()">hier</a> om opzegging ongedaan te maken
                                                                    </small>
                                                                    <small v-else class="text-muted d-block">
                                                                        Klik <a href="#" role="button" @click="togglePackageSubscription()">hier</a> om uw licentie op te zeggen
                                                                    </small>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <span>
                                                                    <h3 class="pb-3">
                                                                        € {{ mainPackage.priceToDisplay | floatVal }}
                                                                    </h3>
                                                                    <h6 class="pb-2">
                                                                        {{ mainPackage.durationToDisplay }}
                                                                    </h6>
                                                                    <b v-if="mainPackage.amount_saving_text" class="pb-3">{{ mainPackage.amount_saving_text }}</b>
                                                                </span>

                                                                <template v-if="!selectedPackage.is_unsubscribed">
                                                                    <div class="mb-3 card-bottom-center">
                                                                        <template v-if="nextProductSubscription && compareWithPackageOption(mainPackage, nextProductSubscription)">
                                                                            <small class="text-muted d-block">{{lang.app.subscription.package_will_activate_on}} {{moment(selectedPackage.license_to_date, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('DD/MM/YYYY')}}</small>
                                                                        </template>
                                                                    </div>
                                                                </template>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <span :class="{'strike-text': (getHasVoucherSubscription() && !getAllowNewOrder())}">
                                                                <h3 class="pb-3">
                                                                    € {{ mainPackage.priceToDisplay | floatVal }}
                                                                </h3>
                                                                <h6 class="pb-2">
                                                                    {{ mainPackage.durationToDisplay }}
                                                                </h6>
                                                                <b v-if="mainPackage.amount_saving_text" class="pb-3">{{ mainPackage.amount_saving_text }}</b>
                                                            </span>
                                                            <div class="mb-2 card-bottom-center">
                                                                <small class="text-muted d-block"><i>Dit abonnement is jaarlijks opzegbaar</i></small>
                                                            </div>
                                                        </template>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-for="(mainPackage, packageIndex) of mainPackageOptions">
                                        <div v-if="givenNonCowOptionVisible(mainPackage)" :class="['col-12 col-md-6 pb-3', {'offset-md-3': !selectedPackage || selectedPackage.id !== 'monthly'}]">
                                            <ul class="price list-group flex-fill"
                                                :style="{cursor: !getAllowNewOrder() ? 'default' : 'pointer'}"
                                                @click="selectPackage(mainPackage)">
                                                <li class="header py-2" :style="compareWithPackageOption(mainPackage) ? {'background-color': '#00DC95', 'color':'#ffffff'} : {'background-color': '', 'color': ''}">
                                                    {{ mainPackage['title'] }}
                                                    <span class="float-right" v-if="getAllowNewOrder()">
                                                    <input type="checkbox" class="mr-2"
                                                           name="yearly"
                                                           :checked="compareWithPackageOption(mainPackage)"
                                                           :text-before="false">
                                                </span>
                                                </li>
                                                <li class="list-group-item" :style="{height: '210px', cursor: 'inherit', 'background-color': compareWithPackageOption(mainPackage) ? '#f8f9fa' : ''}">
                                                    <div class="text-center py-2">
                                                        <template v-if="getHasActiveProductSubscription()">
                                                            <template v-if="compareWithPackageOption(mainPackage)">
                                                                <template v-if="selectedPackage.license_to_date">
                                                                    <template v-if="selectedPackage.is_unsubscribed || (nextProductSubscription && !compareWithPackageOption(mainPackage, nextProductSubscription))">
                                                                        <h3 class="pb-3">
                                                                            {{ lang.app.subscription.ends_on }}
                                                                        </h3>
                                                                        <h6 class="pb-2">
                                                                            {{ moment(selectedPackage.license_to_date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY') }}
                                                                        </h6>
                                                                    </template>
                                                                    <template v-else>
                                                                        <h3 class="pb-3">
                                                                            {{ lang.app.subscription.renew_on }}
                                                                        </h3>
                                                                        <h6 class="pb-2">
                                                                            {{ moment(selectedPackage.license_to_date, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('DD/MM/YYYY') }}
                                                                        </h6>
                                                                    </template>
                                                                </template>
                                                                <template v-else>
                                                                    <h3 class="pb-3">
                                                                        &euro; {{ (selectedPackage.priceToDisplay) | floatVal }}
                                                                    </h3>
                                                                    <h6 class="pb-2">
                                                                        {{ mainPackage.durationToDisplay }}
                                                                    </h6>
                                                                </template>

                                                                <select v-if="mainPackage.monthly_payment_option_package"
                                                                        class="form-control mt-2 col-10 offset-1"
                                                                        v-model="selectedPackage.id"
                                                                        disabled
                                                                        autocomplete="off"
                                                                >
                                                                    <option :value="mainPackage.id">Betaal 12 maanden (€ {{ (mainPackage.farmer_price) | floatVal }})</option>
                                                                    <option :value="mainPackage.monthly_payment_option_package.id">Betaal elke maand (€ {{ (mainPackage.monthly_payment_option_package.farmer_price) | floatVal }})</option>
                                                                </select>
                                                                <div class="my-2 text-center">
                                                                    <small v-if="selectedPackage.is_unsubscribed" class="text-muted d-block">
                                                                        Klik <a href="#" role="button" @click="togglePackageSubscription()">hier</a> om opzegging ongedaan te maken
                                                                    </small>
                                                                    <small v-else class="text-muted d-block">
                                                                        Klik <a href="#" role="button" @click="togglePackageSubscription()">hier</a> om uw licentie op te zeggen
                                                                    </small>
                                                                </div>
                                                                <template v-if="nextProductSubscription && !compareWithPackageOption(mainPackage, nextProductSubscription) && !selectedPackage.is_unsubscribed">
<!--                                                                    <div v-if="user.farmer.animal_base_type !== 'cow'" v-else class="mb-3 card-bottom-center">-->
<!--                                                                        <small class="text-muted d-block">Klik <a href="#" role="button" @click="updateUserNextProductSubscription(mainPackage.monthly_payment_option_package ? mainPackage.monthly_payment_option_package.id : mainPackage.id)">hier</a> om over te schakelen op deze formule</small>-->
<!--                                                                    </div>-->
                                                                </template>
                                                            </template>
                                                            <template v-else>
                                                                <span>
                                                                    <h3 class="pb-3">
                                                                        € {{ mainPackage.priceToDisplay | floatVal }}
                                                                    </h3>
                                                                    <h6 class="pb-2">
                                                                        {{ mainPackage.durationToDisplay }}
                                                                    </h6>
                                                                    <b v-if="mainPackage.amount_saving_text" class="pb-3">{{ mainPackage.amount_saving_text }}</b>
                                                                </span>

                                                                <template v-if="!selectedPackage.is_unsubscribed">
                                                                    <select v-if="mainPackage.monthly_payment_option_package"
                                                                            class="form-control mt-2 col-10 offset-1"
                                                                            :name="mainPackage.id"
                                                                            v-model="mainPackage.selected_payment_option"
                                                                            @click="e => e.stopPropagation()"
                                                                            :disabled="nextProductSubscription && compareWithPackageOption(mainPackage, nextProductSubscription)"
                                                                            autocomplete="off"
                                                                    >
                                                                        <option :value="mainPackage.id">Betaal 12 maanden (€ {{ (mainPackage.farmer_price) | floatVal }})</option>
                                                                        <option :value="mainPackage.monthly_payment_option_package.id">Betaal elke maand (€ {{ (mainPackage.monthly_payment_option_package.farmer_price) | floatVal }})</option>
                                                                    </select>

                                                                    <div class="mb-3 card-bottom-center">
                                                                        <template v-if="nextProductSubscription && compareWithPackageOption(mainPackage, nextProductSubscription)">
                                                                            <small v-if="user.farmer.animal_base_type !== 'cow'" class="text-muted d-block">{{lang.app.subscription.package_will_activate_on}} {{moment(selectedPackage.license_to_date, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('DD/MM/YYYY')}}</small>
                                                                        </template>
<!--                                                                        <template v-else-if="user.farmer.animal_base_type !== 'cow'">-->
<!--                                                                            <small class="text-muted d-block">Klik <a href="#" role="button" @click="updateUserNextProductSubscription(mainPackage.selected_payment_option)">hier</a> om over te schakelen op deze formule</small>-->
<!--                                                                        </template>-->
                                                                    </div>
                                                                </template>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                        <span :class="{'strike-text': (getHasVoucherSubscription() && !getAllowNewOrder())}">
                                                            <h3 class="pb-3">
                                                                € {{ mainPackage.priceToDisplay | floatVal }}
                                                            </h3>
                                                            <h6 class="pb-2">
                                                                {{ mainPackage.durationToDisplay }}
                                                            </h6>
                                                            <b v-if="mainPackage.amount_saving_text" class="pb-3">{{ mainPackage.amount_saving_text }}</b>
                                                        </span>

                                                            <template v-if="!getHasFreeSubscription() && (!getHasVoucherSubscription() || getAllowNewOrder()) && mainPackage.monthly_payment_option_package">
                                                                <select :name="mainPackage.id"
                                                                        class="form-control mt-2 col-10 offset-1"
                                                                        v-model="mainPackage.selected_payment_option"
                                                                        @click="e => e.stopPropagation()"
                                                                        @change="() => selectPackage(mainPackage)"
                                                                        :disabled="!compareWithPackageOption(mainPackage)"
                                                                        autocomplete="off"
                                                                >
                                                                    <option :value="mainPackage.id">Betaal 12 maanden (€ {{ (mainPackage.farmer_price) | floatVal }})</option>
                                                                    <option v-if="selectedPackage && (selectedPackage.id === mainPackage.monthly_payment_option_package.id)" :value="mainPackage.monthly_payment_option_package.id">Betaal elke maand (€ {{ (mainPackage.monthly_payment_option_package.farmer_price) | floatVal }})</option>
                                                                </select>
                                                                <div class="mb-2 card-bottom-center">
                                                                    <small class="text-muted d-block"><i>Dit abonnement is jaarlijks opzegbaar</i></small>
                                                                </div>
                                                            </template>

                                                        </template>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>
                                </template>

                                <div v-if="getHasActiveProductSubscription() && nextRenewalPackageOptions" class="col-12 pb-3 d-flex flex-column">
                                    <div class="list-group-item row d-flex mx-0" style="font-size: 15px">
                                        <div class="col-12 col-md-3 my-auto px-0">
                                            <label class="form-check-label" for="next_renewal_package">
                                                Account bij verlenging :
                                            </label>
                                        </div>
                                        <div class="col-12 col-md-8 my-2 my-md-auto px-0 pl-md-3">
                                            <select class="form-control"
                                                    style="font-size: 15px"
                                                    id="next_renewal_package"
                                                    v-model="nextProductSubscription"
                                                    @click="e => e.stopPropagation()"
                                                    autocomplete="off"
                                                    :disabled="selectedPackage.is_unsubscribed || nextRenewalPackageOptions.length < 2"
                                            >
                                                <option v-for="option in nextRenewalPackageOptions" :value="option">
                                                    {{packageTranslation[option]}} (&euro;{{subscriptionModules.package[option]['farmer_price']}}<span v-if="taxPercentage"> &plus; &euro;{{subscriptionModules.package[option]['farmer_price'] * Math.round(taxPercentage) / 100 | floatVal}} BTW</span>)
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-12 col-md-1 my-auto px-0 pl-md-3 text-center">
                                            <button-loader class="btn bg-green color-white"
                                                           :isLoading="updatingUserNextProductLoader"
                                                           @click="e => updateUserNextProductSubscription()"
                                                           :disabled="updatingUserNextProductLoader || selectedPackage.is_unsubscribed || nextRenewalPackageOptions.length < 2 || user.next_product_subscription===nextProductSubscription">
                                                <i class="fa fa-check"></i>
                                            </button-loader>
                                        </div>
                                    </div>
                                </div>

                                <template v-if="user.farmer.animal_base_type === 'cow'">
                                    <div class="col-12 pb-3 d-flex flex-column">
                                        <div v-if="getAllowNewOrder()" class="list-group-item form-check">
                                            <div class="row">
                                                <div class="col-12 col-md-5 my-auto">
                                                    <input type="checkbox" class="form-check-input mx-0"
                                                           id="voucher_code_checkbox"
                                                           name="voucher_code_checkbox"
                                                           :checked="voucherCheckboxSelected"
                                                           :disabled="!selectedPackage"
                                                           @change="toggleVoucherSelection"
                                                           :text-before="false">
                                                    <label class="form-check-label mx-0 ml-4" for="voucher_code_checkbox">
                                                        Ik heb een voucher code
                                                    </label>
                                                </div>
                                                <div class="col-12 col-md-7">
                                                    <input id="voucher_code" type="text"
                                                           class="form-control"
                                                           name="voucher_code"
                                                           autocomplete="off"
                                                           :disabled="!voucherCheckboxSelected || !selectedPackage"
                                                           v-model="voucherCode"
                                                           @input="debounceVoucherInput">
                                                    <error-ele v-if="this.formError && this.formError['voucher_code']"
                                                               :errors="this.formError['voucher_code']"/>
                                                </div>
                                                <div class="col-12 font-weight-bold mt-3 text-center" v-if="selectedPackage && voucherCheckboxSelected && validVoucherDetails">
                                                    <span v-if="selectedPackage.duration === 1">
                                                        <!--for monthly payment packages, show yearly discount-->
                                                        U bespaart € {{validVoucherDetails.duration * +selectedPackage.farmer_price | floatVal }} ({{validVoucherDetails.duration}} maanden gratis)
                                                    </span>
                                                    <span v-else>
                                                        U bespaart € {{(validVoucherDetails.duration * +selectedPackage.farmer_price / selectedPackage.duration) | floatVal }} ({{validVoucherDetails.duration}} maanden gratis)
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="row mt-2" v-if="adminMode">
                                                <div class="col-12 col-md-5 my-auto">
                                                    <label class="form-check-label mx-0 ml-4" for="discount_amount">
                                                        Discount
                                                    </label>
                                                </div>
                                                <div class="col-12 col-md-7">
                                                    <input id="discount_amount"
                                                           type="number"
                                                           class="form-control"
                                                           name="discount_amount"
                                                           autocomplete="off"
                                                           :disabled="!selectedPackage"
                                                           :max="maxDiscount"
                                                           min="0"
                                                           @focus="$event.target.select()"
                                                           @input="calculatePrice"
                                                           oninput="if (+this.value > +this.max) {this.value = this.max;} else if (+this.value < +this.min) {this.value = this.min;}"
                                                           v-model="discountAmount">
                                                    <error-ele v-if="this.formError && this.formError['discount_amount']"
                                                               :errors="this.formError['discount_amount']"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-if="user.farmer.animal_base_type === 'goat'">
                                    <div class="col-12 pb-3 d-flex flex-column" v-if="getAllowNewOrder() || packageExtraModules.capripedia.is_active">
                                        <div class="list-group-item">
                                            <div>
                                                <span class="sub-prod-name" @click="toggleExtraModuleSelection('capripedia')">
                                                    <input type="checkbox" class="mr-2"
                                                           :name="'capripedia'"
                                                           :checked="packageExtraModules.capripedia.selected"
                                                           :disabled="packageExtraModules.capripedia.disabled"
                                                           :text-before="false">
                                                    {{lang.app.subscription.package.capripedia}}
                                                </span>
                                                <span class="float-right">
                                                    <template v-if="packageExtraModules.capripedia.is_active && packageExtraModules.capripedia.to_date">
                                                        {{ packageExtraModules.capripedia.is_unsubscribed ? lang.app.subscription.ends_on : lang.app.subscription.renew_on}}
                                                        {{ (packageExtraModules.capripedia.is_unsubscribed ? packageExtraModules.capripedia.license_to_date : moment(packageExtraModules.capripedia.license_to_date, 'YYYY-MM-DD HH:mm:ss').add(1, 'days')) | formatDate('DD/MM/YYYY') }}
                                                    </template>
                                                    <template v-else-if="packageExtraModules.capripedia.amount === 0">
                                                        Gratis
                                                    </template>
                                                    <template v-else>
                                                        &euro; {{packageExtraModules.capripedia.amount | floatVal}} /{{packageExtraModules.capripedia.duration}} maanden
                                                    </template>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 pb-3 d-flex flex-column" v-if="getAllowNewOrder()">
                                        <div class="list-group-item form-check">
                                            <div class="row">
                                                <div class="col-12 col-md-5 my-auto">
                                                    <input type="checkbox" class="form-check-input mx-0"
                                                           id="goat_voucher_code_checkbox"
                                                           name="voucher_code_checkbox"
                                                           :checked="voucherCheckboxSelected"
                                                           @change="toggleVoucherSelection"
                                                           :text-before="false">
                                                    <label class="form-check-label mx-0 ml-4" for="goat_voucher_code_checkbox">
                                                        Ik heb een voucher code
                                                    </label>
                                                </div>
                                                <div class="col-12 col-md-7">
                                                    <input id="goat_voucher_code" type="text"
                                                           class="form-control"
                                                           name="voucher_code"
                                                           autocomplete="off"
                                                           :disabled="!voucherCheckboxSelected"
                                                           v-model="voucherCode"
                                                           @input="debounceVoucherInput">
                                                    <error-ele v-if="this.formError && this.formError['voucher_code']"
                                                               :errors="this.formError['voucher_code']"/>
                                                </div>
                                            </div>
                                            <div class="row mt-2" v-if="adminMode">
                                                <div class="col-12 col-md-5 my-auto">
                                                    <label class="form-check-label mx-0 ml-4" for="discount_amount">
                                                        Discount
                                                    </label>
                                                </div>
                                                <div class="col-12 col-md-7">
                                                    <input id="discount_amount"
                                                           type="number"
                                                           class="form-control"
                                                           name="discount_amount"
                                                           autocomplete="off"
                                                           :disabled="!selectedPackage"
                                                           :max="maxDiscount"
                                                           min="0"
                                                           @focus="$event.target.select()"
                                                           @input="calculatePrice"
                                                           oninput="if (+this.value > +this.max) {this.value = this.max;} else if (+this.value < +this.min) {this.value = this.min;}"
                                                           v-model="discountAmount">
                                                    <error-ele v-if="this.formError && this.formError['discount_amount']"
                                                               :errors="this.formError['discount_amount']"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 pb-3 d-flex flex-column" v-if="selectedPackage || voucherCheckboxSelected">
                                        <div class="list-group-item">
                                            <span class="sub-prod-name">
                                                <input type="checkbox" class="mr-2"
                                                       :name="'data_connector'"
                                                       :checked="packageExtraModules.data_connector.selected"
                                                       :disabled="packageExtraModules.data_connector.disabled"
                                                       :text-before="false">
                                                {{lang.app.subscription.package.data_connector}}
                                            </span>
                                            <span class="float-right">
                                                <template v-if="packageExtraModules.data_connector.is_active && packageExtraModules.data_connector.to_date">
                                                    {{(packageExtraModules.data_connector.is_unsubscribed || selectedPackage.id === 'quarterly') ? lang.app.subscription.ends_on : lang.app.subscription.renew_on}}
                                                    {{ ((packageExtraModules.data_connector.is_unsubscribed || selectedPackage.id === 'quarterly') ? (packageExtraModules.data_connector.license_to_date) : moment(packageExtraModules.data_connector.license_to_date, 'YYYY-MM-DD HH:mm:ss').add(1, 'days')) | formatDate('DD/MM/YYYY') }}
                                                </template>
                                                <template v-else-if="packageExtraModules.data_connector.amount === 0">
                                                    Gratis
                                                </template>
                                                <template v-else>
                                                    &euro; {{packageExtraModules.data_connector.amount | floatVal}} /{{packageExtraModules.data_connector.duration}} maanden
                                                </template>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                <template v-if="user.farmer.animal_base_type === 'sheep'">
                                    <div class="col-12 pb-3 d-flex flex-column" v-if="getAllowNewOrder()">
                                        <div class="list-group-item form-check">
                                            <div class="row">
                                                <div class="col-12 col-md-5 my-auto">
                                                    <input type="checkbox" class="form-check-input mx-0"
                                                           id="sheep_voucher_code_checkbox"
                                                           name="voucher_code_checkbox"
                                                           :checked="voucherCheckboxSelected"
                                                           @change="toggleVoucherSelection"
                                                           :text-before="false">
                                                    <label class="form-check-label mx-0 ml-4" for="sheep_voucher_code_checkbox">
                                                        Ik heb een voucher code
                                                    </label>
                                                </div>
                                                <div class="col-12 col-md-7">
                                                    <input id="sheep_voucher_code" type="text"
                                                           class="form-control"
                                                           name="voucher_code"
                                                           autocomplete="off"
                                                           :disabled="!voucherCheckboxSelected"
                                                           v-model="voucherCode"
                                                           @input="debounceVoucherInput">
                                                    <error-ele v-if="this.formError && this.formError['voucher_code']"
                                                               :errors="this.formError['voucher_code']"/>
                                                </div>
                                            </div>
                                            <div class="row mt-2" v-if="adminMode">
                                                <div class="col-12 col-md-5 my-auto">
                                                    <label class="form-check-label mx-0 ml-4" for="discount_amount">
                                                        Discount
                                                    </label>
                                                </div>
                                                <div class="col-12 col-md-7">
                                                    <input id="discount_amount"
                                                           type="number"
                                                           class="form-control"
                                                           name="discount_amount"
                                                           autocomplete="off"
                                                           :disabled="!selectedPackage"
                                                           :max="maxDiscount"
                                                           min="0"
                                                           @focus="$event.target.select()"
                                                           @input="calculatePrice"
                                                           oninput="if (+this.value > +this.max) {this.value = this.max;} else if (+this.value < +this.min) {this.value = this.min;}"
                                                           v-model="discountAmount">
                                                    <error-ele v-if="this.formError && this.formError['discount_amount']"
                                                               :errors="this.formError['discount_amount']"/>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-12 pb-3 d-flex flex-column" v-if="selectedPackage || voucherCheckboxSelected">
                                        <div class="list-group-item">
                                            <span class="sub-prod-name">
                                                <input type="checkbox" class="mr-2"
                                                       :name="'data_connector'"
                                                       :checked="packageExtraModules.data_connector.selected"
                                                       :disabled="packageExtraModules.data_connector.disabled"
                                                       :text-before="false">
                                                {{lang.app.subscription.package.data_connector}}
                                            </span>
                                            <span class="float-right">
                                                <template v-if="packageExtraModules.data_connector.is_active && packageExtraModules.data_connector.to_date">
                                                    {{(packageExtraModules.data_connector.is_unsubscribed || selectedPackage.id === 'quarterly') ? lang.app.subscription.ends_on : lang.app.subscription.renew_on}}
                                                    {{ ((packageExtraModules.data_connector.is_unsubscribed || selectedPackage.id === 'quarterly') ? (packageExtraModules.data_connector.license_to_date) : moment(packageExtraModules.data_connector.license_to_date, 'YYYY-MM-DD HH:mm:ss').add(1, 'days')) | formatDate('DD/MM/YYYY') }}
                                                </template>
                                                <template v-else-if="packageExtraModules.data_connector.amount === 0">
                                                    Gratis
                                                </template>
                                                <template v-else>
                                                    &euro; {{packageExtraModules.data_connector.amount | floatVal}} /{{packageExtraModules.data_connector.duration}} maanden
                                                </template>
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                <template v-if="getHasActiveProductSubscription() && this.isOldPackage()">
                                    <div class="col-12 pb-3 d-flex flex-column">
                                        <div class="list-group-item form-check">
                                            <!--Possible when old packages are still active so show old packages here-->
                                            <div class="row">
                                                <div class="col-12 my-auto text-center">
                                                    <h4>Current active</h4>
                                                    <hr class="my-2">
                                                </div>
                                                <div class="col-4 my-auto offset-2">
                                                    {{lang.app.subscription.package[selectedPackage.id]}}
                                                </div>
                                                <div class="col-4 my-auto">
                                                    {{lang.app.subscription.ends_on}} {{ moment(selectedPackage.to_date, 'YYYY-MM-DD HH:mm:ss') | formatDate('DD/MM/YYYY') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div class="row" v-if="getAllowNewOrder()">
                                <div v-if="selectedPackage && selectedPackage.id.includes('per_month')" class="col-12 col-md-6 mb-3">
                                    <div class="row price-row grey-background">
                                        <div class="col-6 price-col py-1 px-2">Maand</div>
                                        <div class="col-6 price-col py-1 px-2">Bedrag excl BTW</div>
                                    </div>
                                    <div v-for="index in 12" :key="index" class="row price-row">
                                        <template v-if="validVoucherDetails && index <= +validVoucherDetails['duration']">
                                            <div class="col-6 price-col py-1 px-2" style="color: #00DC95">{{index}}</div>
                                            <div class="col-6 price-col py-1 px-2" style="color: #00DC95">
                                                {{index === 1 ? '&euro; 0,02' : '&euro; 0,00'}}
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="col-6 price-col py-1 px-2 font-weight-light">{{index}}</div>
                                            <template v-if="adminMode && discountAmount">
                                                <div class="col-6 price-col py-1 px-2 font-weight-light">
                                                    &euro; {{ (selectedPackage.farmer_price - +discountAmount / (12 - (validVoucherDetails ? validVoucherDetails['duration'] : 0))) | floatVal}}
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="col-6 price-col py-1 px-2 font-weight-light">
                                                    &euro; {{ (selectedPackage.farmer_price) | floatVal}}
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div :class="!(selectedPackage && selectedPackage.id.includes('per_month')) ? 'col-12 col-md-6 offset-md-3' : 'col-12 col-md-6'">
                                    <div>
                                        <div class="row price-row">
                                            <div class="col-8 price-col">
                                                Subtotaal
                                            </div>
                                            <div class="col-4 price-col">
                                                &euro; {{paymentAmount | floatVal}}
                                            </div>
                                        </div>
                                        <div class="row price-row">
                                            <div class="col-8 price-col">
                                                BTW
                                            </div>
                                            <div class="col-4 price-col">
                                                &euro; {{calculatedTax | floatVal}}
                                            </div>
                                        </div>
                                        <div class="row price-row grey-background">
                                            <div class="col-8 price-col">
                                                Totaal incl BTW
                                            </div>
                                            <div class="col-4 price-col">
                                                &euro; {{(paymentAmount + calculatedTax) | floatVal}}
                                            </div>
                                        </div>
                                    </div>
                                    <ul v-if="selectedPackage && selectedPackage.id.includes('per_month') && validVoucherDetails"
                                        class="price list-group flex-fill mt-3">
                                        <li class="header py-2">
                                            Waarom 2 cent?
                                        </li>
                                        <li class="list-group-item" :style="{cursor: 'default', 'background-color': '#f8f9fa'}">
                                            <div class="text-center">
                                                <div class="row">
                                                    <div class="col-12">
                                                        U heeft recht op {{validVoucherDetails['duration']}} maanden gratis Farmdesk. Vanaf maand {{validVoucherDetails['duration'] + 1}} zullen wij automatisch het maandbedrag aanrekenen. Om hiervoor een mandaat te hebben, moet u nu een minimumbedrag van 2 cent betalen.
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <button-loader :isLoading="submitLoader"
                                                   :disabled="submitLoader || disableSubscribeToPackageBtn || !paymentEnabled"
                                                   :classes="'btn btn-block px-md-4 mt-3 bg-green color-white'"
                                                   @click="submitPackage">
                                        {{ paymentAmount ? lang.app.subscription.submit : lang.app.subscription.activate_account }}
                                    </button-loader>
                                </div>

                            </div>
                            <div v-else>
                                <div class="row text-center">
                                    <div class="col-12 col-md-6 offset-md-3">
                                        <a class="btn color-white btn-block bg-green color-w"
                                           href="https://tool.farmdesk.eu/">
                                            {{ lang.app.subscription.to_farmdesk }}
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </template>
                </div>

                <div class="row py-4 justify-content-center" style="margin-top: 20px;">
                    <div class="col-md-8 col-lg-7 col-xl-6 col-xxl-5 d-flex flex-column mt-5 mt-md-0 text-center p-0 px-1">
                        <small>
                            <span>De <u><a :href="route('license-agreement-nl')" class="text-black" target="_blank">Farmdesk gebruikersovereenkomst</a></u> is van toepassing.</span>&nbsp;
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <confirmation-modal
                :message="this.confirmationMessage"
                :is-open="isOpen"
                @result="confirmationResult"
                :product="this.product"
        ></confirmation-modal>
    </div>
</template>
<style scoped>
    .strike-text {
        text-decoration: line-through;
    }
    .card-bottom-center {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: center;
    }
    .free-order-text {
        color: #00DC95;
    }
    .bg-green {
        background-color: #00DC95;
    }
    .price .header {
        background-color: #ededed;
    }
    .price-row {
        font-weight: 600;
        border: 1px solid rgba(51, 51, 51, 0.125);
        border-bottom: none;
        border-left: none;
        padding: 0;
        margin-left: 0;
        margin-right: 0;
    }
    .price-row:first-child {
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
    }
    .price-row:last-child {
        border-bottom: 1px solid rgba(51, 51, 51, 0.125);
        border-bottom-left-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
    }
    .grey-background {
        background-color: #ededed;
    }
    .price-col {
        padding: 0.75rem;
        border-left: 1px solid rgba(51, 51, 51, 0.125);
    }
</style>
<script>
    import PaymentPendingScreen from "./tool/PaymentPendingScreen";
    import SetupPendingScreen from "./tool/SetupPendingScreen";
    import moment from 'moment';

    export default {

        props: ['user', 'adminMode','subscriptionModules', 'paymentEnabled', 'product',
            'taxPercentage', 'animalTypeProducts', 'alertMessage', 'alertType',
            'paymentUnderProcess', 'packagePaymentUrl', 'packagePaymentAmount'],

        components: {
            PaymentPendingScreen,
            SetupPendingScreen,
        },

        data() {
            const goBackUrl = route('Admin.User.GetEdit', {
                'user_id': this.user.userId
            });
            return {
                moment: moment,
                submitLoader: false,
                isOpen: false,
                currentModuleId: null,
                confirmationMessage: null,
                confirmationType: null,

                currentPackageSubscriptions: _.filter(this.user.subscriptionModules || [], {'product': 'package'}),
                selectedPackage: null,
                voucherPackage: null,
                voucherCheckboxSelected: false,
                mainPackageOptions: this.getMainPackageOptions(),
                newCowPackageOptions: this.getNewCowPackageOptions(),
                packageExtraModules: this.getPackageExtraModules(),
                voucherCode: null,
                validVoucherDetails: null,
                debounceVoucherInput: _.debounce(this.voucherCodeUpdated, 800),
                discountAmount: 0,
                maxDiscount: 0,

                paymentAmount: 0,
                calculatedTax: 0,
                disableSubscribeToPackageBtn: true,
                nextProductSubscription: this.user.next_product_subscription,
                nextRenewalPackageOptions: [],
                updatingUserNextProductLoader: false,

                goBackUrl: goBackUrl
            }
        },

        methods: {

            getHasFreeSubscription() {
                return this.selectedPackage && this.selectedPackage.id === 'free_license';
            },

            getHasActiveProductSubscription() {
                return this.selectedPackage && !this.getHasFreeSubscription() && this.selectedPackage.is_active;
            },

            getHasActiveFreeTrialSubscription() {
                return this.voucherPackage && this.voucherPackage.is_active && this.voucherPackage.voucher_usage_obj.voucher.voucher_type === 'free_trial';
            },

            getHasActivePartnerVoucherSubscription() {
                return this.voucherPackage && this.voucherPackage.is_active && this.voucherPackage.voucher_usage_obj.voucher.voucher_type === 'payment_by_partner';
            },

            getHasVoucherSubscription() {
                return this.voucherPackage && this.voucherPackage.is_active;
            },

            isOldPackage() {
                if (!this.selectedPackage || !this.mainPackageOptions) {
                    return false;
                }
                const firstPackage = this.mainPackageOptions[0];
                const secondPackage = this.mainPackageOptions[1];
                const packagesToCheck = [];
                if (firstPackage) {
                    packagesToCheck.push(firstPackage.id)
                    if (firstPackage.monthly_payment_option_package) {
                        packagesToCheck.push(firstPackage.monthly_payment_option_package.id);
                    }
                }
                if (secondPackage) {
                    packagesToCheck.push(secondPackage.id)
                    if (secondPackage.monthly_payment_option_package) {
                        packagesToCheck.push(secondPackage.monthly_payment_option_package.id);
                    }
                }
                if (this.newCowPackageOptions) {
                    this.newCowPackageOptions.forEach(option => {
                        packagesToCheck.push(option.id);
                    });
                }
                return packagesToCheck.indexOf(this.selectedPackage.id) < 0;
            },

            compareWithPackageOption(packageOption, packageIdToCompare = null) {
                if (packageIdToCompare === null) {
                    if (!this.selectedPackage) {
                        return false;
                    }
                    packageIdToCompare = this.selectedPackage.id;
                }

                if (packageOption.id === packageIdToCompare) {
                    return true;
                }
                if (!packageOption.monthly_payment_option_package) {
                    return false;
                }
                return packageOption.monthly_payment_option_package.id === packageIdToCompare;
            },

            getAllowNewOrder() {
                if (this.getHasFreeSubscription()) {
                    return false;
                }
                if (this.getHasActiveProductSubscription()) {
                    return false;
                }
                if (this.getHasActivePartnerVoucherSubscription()) {
                    return false;
                }
                if (this.getHasActiveFreeTrialSubscription()) {
                    return moment(this.voucherPackage.to_date).diff(moment(), 'days') < 10
                }
                return true;
            },


            showNewCowPackages() {
                if (this.user.farmer.animal_base_type !== 'cow') {
                    return false;
                }
                // show new package to all cow farmer with is ordering new
                // otherwise check current subscribed package and decide
                if (this.getAllowNewOrder()) {
                    return true;
                }
                return ['cow_yearly_with_s2f', 'cow_yearly_pro_with_s2f', 'cow_yearly_pro'].indexOf((this.selectedPackage || this.voucherPackage ).id) > -1
            },

            getMainPackageOptions() {
                if (!this.subscriptionModules.package) {
                    // In case of advisor
                    return;
                }
                const animalBaseType = this.user.farmer.animal_base_type;
                const packageModules = this.subscriptionModules.package
                let firstOption = null;
                let secondOption = null;
                if (animalBaseType === 'cow') {

                    firstOption = packageModules['cow_yearly'];
                    firstOption['title'] = 'Farmdesk Tool';
                    firstOption['priceToDisplay'] = +firstOption['farmer_price'] / +firstOption['duration']
                    firstOption['durationToDisplay'] = '/maand'
                    firstOption['monthly_payment_option_package'] = packageModules['cow_yearly_per_month'];
                    firstOption['selected_payment_option'] = this.user.next_product_subscription === 'cow_yearly_per_month' ? 'cow_yearly_per_month' : 'cow_yearly';

                    secondOption = packageModules['cow_yearly_plus'];
                    // secondOption['title'] = 'Farmdesk + Seed2Feed';
                    secondOption['title'] = 'Farmdesk';
                    secondOption['priceToDisplay'] = +secondOption['farmer_price'] / +secondOption['duration']
                    secondOption['durationToDisplay'] = '/maand'
                    secondOption['monthly_payment_option_package'] = packageModules['cow_yearly_plus_per_month'];
                    secondOption['selected_payment_option'] = this.user.next_product_subscription === 'cow_yearly_plus_per_month' ? 'cow_yearly_plus_per_month' : 'cow_yearly_plus';


                } else {

                    firstOption = packageModules['yearly'];
                    firstOption['title'] = lang.app.subscription.package.yearly;
                    firstOption['priceToDisplay'] = +firstOption['farmer_price']
                    firstOption['durationToDisplay'] = '/' + firstOption['duration'].toString() + 'maand'
                    firstOption['monthly_payment_option_package'] = packageModules['yearly_per_month'];
                    firstOption['selected_payment_option'] = this.user.next_product_subscription = 'yearly';
                    firstOption['amount_saving_text'] = 'Bespaar 15%'

                    secondOption = packageModules['monthly'];
                    secondOption['title'] = lang.app.subscription.package.monthly;
                    secondOption['priceToDisplay'] = +secondOption['farmer_price']
                    secondOption['durationToDisplay'] = '/maand'

                }
                return [firstOption, secondOption];
            },

            getNewCowPackageOptions() {
                if (!this.subscriptionModules.package) {
                    // In case of advisor
                    return;
                }
                if (this.user.farmer.animal_base_type !== 'cow') {
                    return;
                }

                const packageModules = this.subscriptionModules.package;

                // option1,2 = for order flow in admin panel
                // option3 = for normal farmer order flow

                const option1 = packageModules['cow_yearly_with_s2f'];
                // option1['title'] = 'Farmdesk + SEED2FEED';
                option1['title'] = 'Farmdesk';
                option1['priceToDisplay'] = +option1['farmer_price'];
                option1['durationToDisplay'] = '/jaar';

                const option2 = packageModules['cow_yearly_pro_with_s2f'];
                // option2['title'] = 'Farmdesk PRO + SEED2FEED';
                option2['title'] = 'Farmdesk PRO';
                option2['priceToDisplay'] = +option2['farmer_price'];
                option2['durationToDisplay'] = '/jaar';

                const option3 = packageModules['cow_yearly_pro'];
                option3['title'] = 'Farmdesk PRO';
                option3['priceToDisplay'] = +option3['farmer_price'];
                option3['durationToDisplay'] = '/jaar';

                return [option1, option2, option3];
            },


            givenNewCowOptionVisible(option) {
                if (!option || ['cow_yearly_pro', 'cow_yearly_with_s2f', 'cow_yearly_pro_with_s2f'].indexOf(option.id) < 0) {
                    return false;
                }
                // For admin mode
                // if no subscription active then only show 1 seed2feed option
                // if 'cow_yearly_pro' subscription is active then show that instead of 'cow_yearly_pro_with_s2f'

                // For user mode
                // if no subscription active then only show 'cow_yearly_pro'
                // Otherwise only show current active module

                const licPackage = this.selectedPackage ? this.selectedPackage : this.voucherPackage;

                if (this.adminMode) {
                    if (licPackage && licPackage.is_active) {
                        if (licPackage.id === 'cow_yearly_pro') {
                            return option.id === 'cow_yearly_pro';
                        } else if (licPackage.id === 'cow_yearly_with_s2f') {
                            return ['cow_yearly_with_s2f', 'cow_yearly_pro_with_s2f'].includes(option.id);
                        }
                        return option.id === 'cow_yearly_pro_with_s2f';
                    }
                    // Only show "cow_yearly_pro_with_s2f" is no active license
                    return option.id === 'cow_yearly_pro_with_s2f';
                }

                if (licPackage && licPackage.is_active) {
                    return option.id === licPackage.id;
                }
                return option.id === 'cow_yearly_pro';
            },

            givenNonCowOptionVisible(option) {
                if (!option || !['yearly', 'yearly_per_month', 'monthly'].includes(option.id)) {
                    return false;
                }

                const licPackage = this.selectedPackage ? this.selectedPackage : this.voucherPackage;

                if (licPackage && licPackage.is_active && licPackage.id === option.id) {
                    return true;
                }

                return option.id === 'yearly';
            },

            getPackageExtraModules() {
                if (!this.subscriptionModules.package) {
                    // In case of advisor
                    return;
                }
                return {
                    'lactipedia': {
                        'selected': false,
                        'disabled': true,
                        'duration': this.subscriptionModules.package.individual_modules.lactipedia.duration,
                        'amount': this.subscriptionModules.package.individual_modules.lactipedia.farmer_price,
                    },
                    'capripedia': {
                        'selected': false,
                        'disabled': true,
                        'duration': this.subscriptionModules.package.individual_modules.capripedia.duration,
                        'amount': this.subscriptionModules.package.individual_modules.capripedia.farmer_price,
                    },
                    'data_connector': {
                        'selected': true,
                        'disabled': true,
                        'duration': null,
                        'amount': null,
                    },
                    'invoice_lines': []
                };
            },

            checkPackageSubscription() {
                this.currentPackageSubscriptions.forEach((subscription) => {
                    const module = subscription['module'];
                    const voucherUsage = subscription['voucher_usage_obj'];

                    if (['yearly', 'quarterly', 'monthly', 'yearly_per_month', 'cow_yearly', 'cow_yearly_per_month',
                        'cow_yearly_plus', 'cow_yearly_plus_per_month', 'cow_yearly_with_s2f', 'cow_yearly_pro_with_s2f', 'cow_yearly_pro'].indexOf(module) >= 0) {

                        const packageSub = _.clone(this.subscriptionModules.package[module]);
                        packageSub['db_id'] = subscription['id'];
                        packageSub['is_active'] = subscription['is_active'];
                        packageSub['to_date'] = subscription['to_date'];
                        packageSub['is_unsubscribed'] = subscription['is_unsubscribed'];
                        packageSub['voucher_usage_obj'] = voucherUsage;
                        packageSub['license_to_date'] = subscription['license_to_date'] || subscription['to_date']

                        if (voucherUsage && _.get(voucherUsage, 'voucher.voucher_type') !== 'free_2_months') {
                            this.voucherPackage = packageSub
                        } else {
                            this.selectedPackage = packageSub;
                        }

                    } else if (module === 'invoice_line') {
                        this.packageExtraModules['invoice_lines'].push(
                            {
                                db_id: subscription['id'],
                                is_unsubscribed: subscription['is_unsubscribed']
                            }
                        );
                    } else if (!voucherUsage) {
                        this.packageExtraModules[module]['db_id'] = subscription['id'];
                        this.packageExtraModules[module]['selected'] = true;
                        this.packageExtraModules[module]['disabled'] = true;
                        this.packageExtraModules[module]['is_active'] = subscription['is_active'];
                        this.packageExtraModules[module]['to_date'] = subscription['to_date'];
                        this.packageExtraModules[module]['license_to_date'] = subscription['license_to_date'] || subscription['to_date'];
                        this.packageExtraModules[module]['is_unsubscribed'] = subscription['is_unsubscribed'];
                    }
                });

                if (this.selectedPackage) {

                    // If nextProductSubscription is blank for cow farmers then fill it up based on current package
                    // Old cow farmers with `plus` licenses will be renewed to `cow_yearly_pro_with_s2f` license
                    // otherwise to normal `cow_yearly_pro` license unless changed by admin
                    let updateNextProductSubInDb = false;
                    if (!this.nextProductSubscription) {
                        this.nextProductSubscription = this.selectedPackage['id'];
                        updateNextProductSubInDb = true;
                    }
                    if (this.user.farmer.animal_base_type === 'cow' && ['cow_yearly_pro_with_s2f', 'cow_yearly_pro'].indexOf(this.nextProductSubscription) < 0) {
                        // User with license "cow_yearly_with_s2f" should also be migrated to "cow_yearly_pro_with_s2f"
                        this.nextProductSubscription = ['cow_yearly_plus', 'cow_yearly_plus_per_month', 'cow_yearly_with_s2f'].indexOf(this.nextProductSubscription) > -1 ? 'cow_yearly_pro_with_s2f' : 'cow_yearly_pro';
                        updateNextProductSubInDb = true;
                    } else if (['monthly', 'yearly_per_month'].includes(this.nextProductSubscription)) {
                        // Convert goat users to "yearly" license
                        this.nextProductSubscription = 'yearly';
                        updateNextProductSubInDb = true;
                    }
                    if (updateNextProductSubInDb) {
                        this.updateUserNextProductSubscription();
                    }

                    // Update renewal package options based on current active package
                    if (this.user.farmer.animal_base_type === 'cow') {
                        if (['cow_yearly_with_s2f', 'cow_yearly_pro_with_s2f'].indexOf(this.selectedPackage['id']) > -1) {
                            this.nextRenewalPackageOptions = ['cow_yearly_pro_with_s2f'];
                        } else {
                            // Only show regular 'cow_yearly_pro' for non-plus license and `cow_yerly_pro_with_s2f` for plus licenses as renewal options if admin didn't specify anything else
                            this.nextRenewalPackageOptions = [['cow_yearly_plus', 'cow_yearly_plus_per_month'].indexOf(this.selectedPackage['id']) > -1 ? 'cow_yearly_pro_with_s2f' : 'cow_yearly_pro'];
                        }

                        // For next renewal is not in list then add it. This happens when admin change it from subscription info page
                        if (this.nextRenewalPackageOptions.indexOf(this.nextProductSubscription) < 0) {
                            this.nextRenewalPackageOptions.push(this.nextProductSubscription);
                        }
                    } else {
                        this.nextRenewalPackageOptions = ['yearly'];
                    }
                }

                this.calculatePrice();
            },

            selectPackage(pkg) {
                if (!this.getAllowNewOrder()) {
                    return;
                }

                if (pkg && pkg.monthly_payment_option_package && pkg.selected_payment_option === pkg.monthly_payment_option_package.id) {
                    pkg = pkg.monthly_payment_option_package;
                }
                // If user clicks on selected package then remove package selection
                if (this.selectedPackage && pkg && this.selectedPackage.id === pkg.id) {
                    pkg = null;
                }
                this.selectedPackage = pkg;

                if (this.selectedPackage && this.user.farmer.animal_base_type !== 'cow') {
                    this.voucherCheckboxSelected = false;
                }

                if (this.user.farmer.animal_base_type === 'goat') {
                    this.packageExtraModules['data_connector'] = {
                        'selected': this.selectedPackage || this.voucherCheckboxSelected,
                        'disabled': true,
                        'duration': this.selectedPackage ? this.selectedPackage.add_ons.data_connector.duration : null,
                        'amount': this.selectedPackage ? this.selectedPackage.add_ons.data_connector.farmer_price : null,
                    };
                    this.packageExtraModules['capripedia']['selected'] = this.selectedPackage ? this.packageExtraModules['capripedia']['selected'] : this.voucherCheckboxSelected;
                    this.packageExtraModules['capripedia']['disabled'] = !this.selectedPackage;
                    this.packageExtraModules['capripedia']['amount'] = this.voucherCheckboxSelected ? null : this.subscriptionModules.package.individual_modules.capripedia.farmer_price;

                } else if (this.user.farmer.animal_base_type === 'sheep') {

                    this.packageExtraModules['data_connector'] = {
                        'selected': this.selectedPackage || this.voucherCheckboxSelected,
                        'disabled': true,
                        'duration': this.selectedPackage ? this.selectedPackage.add_ons.data_connector.duration : null,
                        'amount': this.selectedPackage ? this.selectedPackage.add_ons.data_connector.farmer_price : null,
                    };

                }

                this.updateSubscribeToPackageBtn();
                this.calculatePrice();
            },

            toggleExtraModuleSelection(moduleName) {
              if (this.packageExtraModules[moduleName]['disabled']) {
                  return;
              }
              this.packageExtraModules[moduleName]['selected'] = !this.packageExtraModules[moduleName]['selected'];
              this.calculatePrice();
            },

            toggleVoucherSelection() {
                this.voucherCheckboxSelected = !this.voucherCheckboxSelected;
                this.voucherCode = '';
                this.validVoucherDetails = null;
                this.formError = null;
                this.updateSubscribeToPackageBtn();
                if (this.user.farmer.animal_base_type === 'cow') {
                    this.calculatePrice();
                    return;
                }
                this.selectPackage(null);
            },

            voucherCodeUpdated() {
                if (!this.voucherCode || !this.voucherCode.trim()) {
                    this.validVoucherDetails = null;
                    this.updateSubscribeToPackageBtn();
                    return;
                }
                api.subscription.postValidateVoucherCodeAction({
                    'user_id': this.user.userId,
                    'animal_base_type': this.user.farmer.animal_base_type,
                    'voucher_code': this.voucherCode.trim()
                }).then(response => {
                    this.validVoucherDetails = response.data;
                    this.formError = null;
                }).catch(error => {
                    this.validVoucherDetails = null;
                    if (error.response.status === 422) {
                        if (error.response && error.response.data) {
                            this.formError = error.response.data;
                        }
                    }
                }).finally(() => {
                    this.updateSubscribeToPackageBtn();
                    this.calculatePrice();
                })
            },

            updateSubscribeToPackageBtn() {
                if (this.user.role === 'advisor') {
                  return;
                }
                this.disableSubscribeToPackageBtn = false;
                if (this.user.farmer.animal_base_type === 'cow') {
                    this.disableSubscribeToPackageBtn = !(this.selectedPackage && (!this.voucherCheckboxSelected || this.validVoucherDetails));
                } else {
                    this.disableSubscribeToPackageBtn = !(this.selectedPackage || (this.voucherCheckboxSelected && this.validVoucherDetails));
                }
            },

            calculatePrice() {
                if (this.user.role === 'advisor') {
                    return;
                }

                if (!this.selectedPackage) {
                    this.paymentAmount = 0;
                    this.calculatedTax = 0;
                    this.maxDiscount = 0;
                    this.discountAmount = 0;
                    return;
                }

                let totalPrice = 0;
                const isMonthlyPaymentOption = this.selectedPackage.duration === 1;

                let packagePrice = parseFloat(this.selectedPackage.farmer_price);
                if (this.validVoucherDetails) {
                    if (isMonthlyPaymentOption) {
                        packagePrice = 0.02;
                    } else {
                        packagePrice -= this.validVoucherDetails.duration * packagePrice / this.selectedPackage.duration;
                    }
                }
                totalPrice += packagePrice;

                if (this.user.farmer.animal_base_type === 'goat' && this.packageExtraModules.capripedia.selected && this.packageExtraModules.capripedia.amount) {
                    totalPrice += parseFloat(this.packageExtraModules.capripedia.amount);
                }

                if (['goat', 'sheep'].indexOf(this.user.farmer.animal_base_type) >= 0 && this.packageExtraModules.data_connector.selected && this.packageExtraModules.data_connector.amount) {
                    totalPrice += parseFloat(this.packageExtraModules.data_connector.amount);
                }

                let maxDiscount = 0;
                if (isMonthlyPaymentOption) {
                    if (this.validVoucherDetails) {
                        maxDiscount = parseFloat(this.selectedPackage.farmer_price) * (12 - this.validVoucherDetails.duration);
                    } else {
                        maxDiscount = parseFloat(this.selectedPackage.farmer_price) * 12;
                    }
                } else {
                    maxDiscount = totalPrice;
                }
                this.maxDiscount = _.floor(maxDiscount);

                if (!this.adminMode || !this.discountAmount) {
                    this.paymentAmount = totalPrice;
                    this.calculatedTax = totalPrice * Math.round(this.taxPercentage) / 100;
                    return;
                }

                let paymentAmount = totalPrice;
                if (isMonthlyPaymentOption && !this.validVoucherDetails) {
                    paymentAmount -= +this.discountAmount / 12;
                } else if (!isMonthlyPaymentOption) {
                    paymentAmount -= +this.discountAmount;
                }
                this.paymentAmount = paymentAmount;
                this.calculatedTax = paymentAmount * Math.round(this.taxPercentage) / 100;
            },

            advisorRequest() {
                this.messageText = null;
                this.messageStatus = null;

                setTimeout(() => {
                    this.submitLoader = true;
                    return api.subscription
                        .postCreateSubscriptionAction({'user_api_id': this.user.id})
                        .then(response => {
                            this.submitLoader = false;
                            this.formError = null;
                            this.messageText = response.data.message;
                            this.messageStatus = 'success';

                            window.location.reload();
                        })
                        .catch(error => {
                            if (error.response.status === 422) {
                                this.messageText = lang.validation.error_message;
                                this.messageStatus = "error";
                                if (error.response && error.response.data) {
                                    this.formError = error.response.data;
                                }
                            }
                            this.submitLoader = false;
                        });
                }, 500);
            },

            submitPackage() {
                this.messageText = null;
                this.messageStatus = null;

                const pedias = [];
                if (this.user.farmer.animal_base_type === 'goat' && this.packageExtraModules.capripedia.selected) {
                    pedias.push('capripedia');
                }

                const extraModules = [];
                if (this.user.farmer.animal_base_type !== 'cow' && this.packageExtraModules.data_connector.selected) {
                    extraModules.push('data_connector');
                }

                setTimeout(() => {

                    const body = {
                        'user_api_id': this.user.id,
                        'animal_base_type': this.user.farmer.animal_base_type,
                        'package_name': this.selectedPackage ? this.selectedPackage.id : null,
                        'pedias': pedias,
                        'extra_modules': extraModules,
                        'voucher_code': this.voucherCheckboxSelected ? this.voucherCode.trim() : null,
                        'discount_amount': this.selectedPackage && this.adminMode ? this.discountAmount : 0
                    };
                    this.submitLoader = true;
                    return api.subscription
                        .postCreateSubscriptionPackage(body)
                        .then(response => {
                            this.submitLoader = false;
                            this.formError = null;
                            this.messageText = response.data.message;
                            this.messageStatus = 'success';
                            window.location.reload();
                        })
                        .catch(error => {
                            if (error.response.status === 422) {
                                this.messageText = lang.validation.error_message;
                                this.messageStatus = "error";
                                if (error.response && error.response.data) {
                                    this.formError = error.response.data;
                                }

                            }
                            this.submitLoader = false;
                        });
                }, 500);
            },

            togglePackageSubscription() {
                if (!this.selectedPackage.db_id) {
                    return;
                }
                this.messageText = null;
                this.messageStatus = null;
                this.currentModuleId = this.selectedPackage.db_id;
                if (this.selectedPackage.is_unsubscribed) {
                    this.confirmationMessage = lang.app.subscription.subscribe_confirmation_message;
                    this.confirmationType = 'subscribe';
                    this.isOpen = true;
                } else {
                    this.confirmationMessage = lang.app.subscription.unsubscribe_confirmation_message;
                    this.confirmationType = 'unsubscribe';
                    this.isOpen = true;
                }
            },

            confirmationResult(result) {
                this.isOpen = false;
                if (!result) {
                    return;
                }
                this.submitSubscriptionToggle(this.confirmationType === 'unsubscribe');
            },

            submitSubscriptionToggle(isUnsubscribed) {
                this.messageText = null;
                this.messageStatus = null;
                const subscriptionIds = [this.currentModuleId];
                if (this.selectedPackage && this.selectedPackage.db_id) { // If package subscription then also unsubscribed related modules
                    for (const module in this.packageExtraModules) {
                        if (!this.packageExtraModules.hasOwnProperty(module)) {
                            continue;
                        }
                        if (module === 'invoice_lines') {
                            this.packageExtraModules['invoice_lines'].forEach((item) => {
                                if (item['db_id']) {
                                    subscriptionIds.push(item['db_id']);
                                }
                            });
                        } else if (this.packageExtraModules[module]['db_id']) {
                            subscriptionIds.push(this.packageExtraModules[module]['db_id']);
                        }
                    }
                }

                return api.subscription
                    .postUpdateIsUnsubscribeAction({'user_api_id': this.user.id, 'ids': subscriptionIds, 'is_unsubscribed': isUnsubscribed})
                    .then(response => {
                        if (response.data.updatedSubscriptions) {
                            for (let idx in this.currentPackageSubscriptions) {
                                if (!this.currentPackageSubscriptions.hasOwnProperty(idx)) {
                                    continue;
                                }
                                const currSub = this.currentPackageSubscriptions[idx]
                                let updatedSub = _.find(response.data.updatedSubscriptions, {'id': currSub.id});
                                if (updatedSub) {
                                    currSub.is_unsubscribed = updatedSub.is_unsubscribed;
                                    currSub.license_to_date = updatedSub.license_to_date;
                                    _.set(this.currentPackageSubscriptions, idx, currSub);
                                }
                            }
                            this.checkPackageSubscription();
                        }
                        this.currentModuleId = null;
                        this.confirmationMessage = null;
                        this.confirmationType = null;
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.messageText = lang.validation.error_message;
                            this.messageStatus = "error";
                        }
                        this.currentModuleId = null;
                        this.confirmationMessage = null;
                        this.confirmationType = null;
                    })
            },

            updateUserNextProductSubscription() {
                this.updatingUserNextProductLoader = true;
                return api.subscription
                    .postUpdateUserNextProductSubscription({'user_api_id': this.user.id, 'package': this.nextProductSubscription})
                    .then(response => {
                        this.user.next_product_subscription = this.nextProductSubscription;
                        this.updatingUserNextProductLoader = false;
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.messageText = lang.validation.error_message;
                            this.messageStatus = "error";
                        }
                        this.updatingUserNextProductLoader = false;
                    });
            }
        },

        created() {
            if (this.alertMessage && this.alertType) {
                this.messageText = this.alertMessage;
                this.messageStatus = this.alertType;
            }
            this.packageTranslation = {
                // 'cow_yearly_with_s2f': 'SEED2FEED powered by Farmdesk BASIC',
                // 'cow_yearly_pro_with_s2f': 'SEED2FEED powered by Farmdesk PRO',
                'cow_yearly_with_s2f': 'Farmdesk BASIC',
                'cow_yearly_pro_with_s2f': 'Farmdesk PRO',
                'cow_yearly_pro': 'Farmdesk PRO software',
                'yearly': lang.app.subscription.package.yearly,
                'yearly_per_month': lang.app.subscription.package.yearly + ' (Betaal maandelijks)',
                'monthly': lang.app.subscription.package.monthly
            };
            this.checkPackageSubscription();
            this.updateSubscribeToPackageBtn();
        },


    }
</script>



// WEBPACK FOOTER //
// resources/js/components/subscription/ToolSubscriptionForm.vue